<label class="im:card portal-card" [class.disabled]="isDisabled">
  <span class="logo">
    <app-image defaultSrc="{{ imgUrl() }}" maxHeightInPx="72"></app-image>
  </span>

  <span class="info">
    <span class="im:body title">{{ title() | translate }}</span>
    <ng-content select="[description]"></ng-content>
  </span>

  @if (selectable() || isSelected) {
    <span
      class="checkbox"
      [imTooltip]="
        showDeselectionDisabledTooltip ? deselectionDisabledTooltip : null
      "
    >
      <input
        type="checkbox"
        class="im:checkbox-input"
        [formControl]="checkControl"
        [attr.disabled]="isDisabled ? '' : null"
      />
    </span>
  }

  <!-- keeps a menu click from toggling the surrounding label -->
  <span class="context-menu" (click)="$event.preventDefault()">
    <ng-content select="[context-menu]"></ng-content>
  </span>
</label>

<ng-template #deselectionDisabledTooltip>
  <span>{{ deselectDisabledText() | translate }}</span>
</ng-template>
